import React, { useEffect, useState } from 'react';
import { Spinner } from '../../../../common';
import StudyProgramsTable from './StudyProgramsTable.jsx';
import { routes } from '../../../../../utils/helpers/ApiClient';
import { AppBarCMS } from '../../../../basic';
import CollapseBlock from '../../../../common/blocks/CollapseBlock/CollapseBlock';
import TableFilter from '../../../../common/TableFilter/TableFilter.jsx';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import {
  useDeleteStudyProgramMutation,
  useGetStudyProgramsAdminQuery,
} from '../../../../../redux/services/study_programs';
import { useToastMessages } from '../../../../../hooks/useToastMessages';

const TABLE_FILTER_TITLE = 'Filter študijných programov';

const StudyProgramsPage = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const {
    deleteSuccess,
  } = useToastMessages();

  // Selected list option for the table (active/archived)
  const [selectedOption, setSelectedOption] = useState(
    localStorage.getItem(TABLE_FILTER_TITLE) || 'active'
  );

  const {
    data: studyPrograms,
    isLoading,
    refetch,
  } = useGetStudyProgramsAdminQuery({ archived: selectedOption === 'archived' });

  const [
    deleteStudyProgram,
    {
      isSuccess: isDeleteSuccess,
    },
  ] = useDeleteStudyProgramMutation();

  useEffect(() => {
    document.title = t('Študijné programy') + ' - FRI CMS';
  }, []);

  useEffect(() => {
      if (isDeleteSuccess) {
        deleteSuccess();
        navigate(routes.cmsStudyPrograms);
        refetch();
      }
  }, [isDeleteSuccess]);

  return isLoading ? (
    <Spinner />
  ) : (
    <>
      <AppBarCMS
        title={t('Študijné programy')}
        backUrl={routes.cmsDashboard}
        backUrlTooltip={t('Nástenka')}
        createText={t('Pridať študijný program')}
        createUrl={routes.cmsStudyProgramsCreate}
        permissionsBasic="study-programs"
      />
      <div style={{ margin: '10px' }}>
        <TableFilter
          title={t(TABLE_FILTER_TITLE)}
          value={selectedOption}
          setValue={setSelectedOption}
          options={[
            { value: 'active', label: t('Aktívne') },
            { value: 'archived', label: t('Archivované') },
          ]}
        />

        <CollapseBlock>
          <StudyProgramsTable
            studyPrograms={studyPrograms}
            onDelete={record => deleteStudyProgram(record.id)}
            onDetailClick={record =>
              navigate(`${routes.cmsStudyProgramsEdit}/${record.id}`)
            }
            onCreateClick={() => navigate(routes.cmsStudyProgramsCreate)}
          />
        </CollapseBlock>
      </div>
    </>
  );
};

export default StudyProgramsPage;
